module.exports = __webpack_public_path__ + "img/icons-lock.8ec7b60c.svg";